<template>
  <div class="sliding-menu-page">
    <!-- Top Navigation -->
    <div class="top-nav">
      <button 
        class="nav-button" 
        :class="{ active: activeMenu === 'left' }"
        @click="switchMenu('left')"
      >
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <rect x="3" y="3" width="7" height="7"/>
          <rect x="14" y="3" width="7" height="7"/>
          <rect x="3" y="14" width="7" height="7"/>
          <rect x="14" y="14" width="7" height="7"/>
        </svg>
      </button>

      <button 
        class="nav-button" 
        :class="{ active: activeMenu === 'right' }"
        @click="switchMenu('right')"
      >
        <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2">
          <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z"/>
        </svg>
      </button>
    </div>

    <!-- Sliding Content Container -->
    <div class="content-wrapper">
      <div class="content-slider" :style="sliderStyle">
        <!-- Left Menu Content -->
        <div class="menu-content">
            <AudioCard 
                @click=" this.$root.$refs.audioPlayers.show(
                  audios.public,
                  index,
                  parentPseudo+' ( Public )' 
                )" 
                v-for="(audio,index) in audios.public" :key="index" :audio="audio" 
                ref="publicAudios"
                @playingEnded="playNextPublic(index)"
                style="z-index: 1;"/>
            <div class="loader"><img v-show="loading.public" src="./img/loader.svg"/></div>
            <div v-show="!loading.public && audios.public.length==0" class="menu-private">
              <span>No publication found.</span>
            </div>
        </div>

        <!-- Right Menu Content -->
        <div class="menu-content">
          <AudioCard 
            @click=" this.$root.$refs.audioPlayers.show(
              audios.private,
              index,
              parentPseudo+' ( Private )' 
            )" 
            v-for="(audio,index) in audios.private" :key="index" :audio="audio" style="z-index: 1;"/>
          <div class="loader"><img v-show="loading.private" src="./img/loader.svg"/></div>
          <div v-show="!loading.private && audios.private.length==0&&canSeePrivate" class="menu-private">
            <span>No publication found.</span>
          </div>
          <div v-show="!canSeePrivate" class="menu-private">
            <h3>This are private audio.</h3>
            <span>You can only see this content if your are friend with. Which means when you will follow each other.</span>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import AudioCard from '@/views/components/audioCard/AudioCard.vue'

export default {
  name: 'SlidingMenu',
  props:{
    canSeePrivate:{
      type: Boolean,
      default:false,
    },
    parentPseudo:{
      type: String,
      default:'',
    }
  },
  components: {
    AudioCard,
  },
  data() {
    return {
      activeMenu: 'left', // 'left' or 'right'
      loading:{public:false,private:false},
      uid:'',
      audios:{public:[],private:[]},
      rightLoaded:false
    }
  },
  computed: {
    sliderStyle() {
      return {
        transform: this.activeMenu === 'left' ? 'translateX(0)' : 'translateX(-50%)'
      }
    }
  },
  methods: {
    reset() {
      this.activeMenu = 'left', // 'left' or 'right'
      this.loading = {public:false,private:false},
      this.uid = '',
      this.audios = {public:[],private:[]},
      this.rightLoaded = false
    },
    async switchMenu(menu) {
      this.activeMenu = menu;
      if(menu=='right' && !this.rightLoaded) {
        await this.getPubs('private',this.uid)
        this.rightLoaded = true
      }
    },
    playNextPublic (index) {
      if(index+1>=this.audios.public.length) return
      this.$refs.publicAudios[index+1].togglePlay()
    },  
    async getPubs (type,uid) {
      this.uid = uid
      this.loading[type] = true 
      try {
          const res = await this.$axios.post('publication.php',{type:"getUserPublications",
          userId:uid,pubType:type,from:new Date()})
          //console.log('pubbbb',res.data)
          //this.$store.commit('addPlayLists',{index:0,audio:res.data[5]})
          this.audios[type] = res.data
      } catch (e) {
          console.log(e.response?.data?.error || e.message);
      } finally {this.loading[type] = false}
    },
  },
  watch: {
    '$store.state.modifiedPublication.count' () {
      const pub = this.$store.state.modifiedPublication.publication
      const type = pub.type !== 'private' ? 'public' :'private'
      const index = this.audios[type].findIndex(pb => pb._id === pub._id)
      if(index !==-1)  {
        if(pub.type1 === 'delete') {// deleting from object
          this.audios[type].splice(index,1)
          return
        }
        this.audios[type][index] = pub // modify
      }
      else this.audios[type].unshift(pub) // add
    }
  }
}
</script>

<style scoped>
.sliding-menu-page {
  background: #0a0e26;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial, sans-serif;
  padding-bottom: 100px;
}

.top-nav {
  position: sticky;
  top: 0;
  left: 0;
  right: 0;
  display: flex;
  background: #0a0e26;
  border-bottom: 1px solid rgba(0, 212, 255, 0.1);
  z-index: 1;
  padding: 12px 20px;
  gap: 12px;
}

.nav-button {
  flex: 1;
  background: transparent;
  border: none;
  color: #94a3b8;
  padding: 12px;
  cursor: pointer;
  border-radius: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  position: relative;
}

.nav-button svg {
  width: 28px;
  height: 28px;
}

.nav-button.active {
  background: rgba(30, 41, 59, 0.8);
  color: #00d4ff;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.3);
}

.nav-button.active::after {
  content: '';
  position: absolute;
  bottom: -12px;
  left: 50%;
  transform: translateX(-50%);
  width: 60%;
  height: 3px;
  background: #00d4ff;
  border-radius: 2px;
  box-shadow: 0 0 8px rgba(0, 212, 255, 0.6);
}

.nav-button:hover:not(.active) {
  background: rgba(30, 41, 59, 0.4);
  color: #e0f7ff;
}

.content-wrapper {
  overflow: hidden;
  width: 100%;
}

.content-slider {
  display: flex;
  width: 200%;
  transition: transform 0.4s cubic-bezier(0.4, 0, 0.2, 1);
}

.menu-content {
  position: relative;
  width: 50%;
  display: flex;
  flex-wrap: wrap;
}
.menu-private {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
}
.menu-private > h3 {
    color: #e0f7ff;
}
.menu-private > span {
    color: #94a3b8;
}
.loader {
  width: 100%;
  margin-top: 10px;
}
.loader img {
  width: 100px;
}

@media (max-width: 768px) {
  .top-nav {
    padding: 10px 16px;
  }

  .nav-button svg {
    width: 24px;
    height: 24px;
  }

  .placeholder-grid {
    gap: 1px;
  }

  .placeholder-item {
    font-size: 12px;
  }
}
</style>